<div>
  <ng-container *ngIf="getTitle()">
    <app-youre-done-card
      [title]="getTitle()"
      [youreDoneData]="youreDone"
      [quoteRequestState]="quoteRequestState"
      [outcomeImageSrc]="getOutcomeImage()"
      [hideDocuments]="hideDocuments()"
    >
      <div statement-content>
        <p *ngIf="isQuoteOwner()">
          {{ getQuoteOwnerMessage() }}
        </p>
        <p *ngIf="!isQuoteOwner()">
          {{ getNonQuoteOwnerMessage() }}
        </p>
      </div>

      <div rejection-reason-content *ngIf="quoteState === quoteStateType.OFFER_REJECTED || quoteState === quoteStateType.APPROVAL_REJECTED">
        <section *ngIf="youreDone.quoteRejectedReason">
          <h4>Offer Rejection Reason</h4>
          <p class="keep-line-breaks">{{ youreDone.quoteRejectedReason.replace('\\', '') }}</p>
        </section>

        <section *ngIf="youreDone.quoteRanking">
          <h4>Where Did We Rank?</h4>
          <p>{{ youreDone.quoteRanking }}</p>
        </section>

        <section *ngIf="youreDone.quoteFeedback">
          <h4>Quote Feedback</h4>
          <div class="screenWidth">
            <p class="keep-line-breaks">
              <em>{{ youreDone.quoteFeedback }}</em>
            </p>
          </div>
        </section>
      </div>

      <div action-buttons>
        <ng-container *ngTemplateOutlet="defaultButtons"></ng-container>
      </div>
    </app-youre-done-card>
  </ng-container>
</div>

<ng-template #defaultButtons>
  <div class="body-buttons top-m-8x">
    <button
      *ngIf="isCustomEnabled()"
      mat-flat-button
      color="accent"
      type="button"
      [routerLink]="['../../../', 'custom', 'new', 'customer-details']"
    >
      <mat-icon matPrefix>note_add</mat-icon>
      Start a New Custom Quote
    </button>
    <button
      *ngIf="isMatrixEnabled()"
      mat-flat-button
      color="accent"
      type="button"
      [routerLink]="['../../../', 'matrix', 'new', 'customer-details']"
    >
      <mat-icon matPrefix>note_add</mat-icon>
      Start a New Matrix Quote
    </button>
    <button mat-flat-button color="accent" type="button" [routerLink]="['../../../']">
      <mat-icon matPrefix>speed</mat-icon>
      View Dashboard
    </button>
    <button mat-flat-button color="accent" type="button" [routerLink]="['../../../', 'quotes']">
      <mat-icon matPrefix>equalizer</mat-icon>
      View Quotes
    </button>
  </div>
</ng-template>
